export const COMPARISON_CARD = {
  "Cardreport.Comparisoncard.Hover.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Comparisoncard.Hover.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Comparisoncard.Hover.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Comparisoncard.Hover.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Comparisoncard.Hover.Border.Color": {
    ref: "Color.Gray.300"
  },
  "Cardreport.Comparisoncard.Hover.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Cardreport.Comparisoncard.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Comparisoncard.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Comparisoncard.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Comparisoncard.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Cardreport.Comparisoncard.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Cardreport.Comparisoncard.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Cardreport.Comparisoncard.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Cardreport.Comparisoncard.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Cardreport.Comparisoncard.Border.Color": {
    ref: "Color.Gray.300"
  },
  "Cardreport.Comparisoncard.Border.Style": {
    defaultValue: "solid"
  },
  "Cardreport.Comparisoncard.Actualvalue.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Comparisoncard.Actualvalue.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Comparisoncard.Targetvalue.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Comparisoncard.Targetvalue.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Comparisoncard.Actuallabel.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Comparisoncard.Actuallabel.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Comparisoncard.Targetlabel.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Comparisoncard.Targetlabel.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Comparisoncard.Content.Align.Vertical": {
    defaultValue: "center"
  },
  "Cardreport.Comparisoncard.Content.Align.Horizontal": {
    defaultValue: "flex-start"
  },
  "Cardreport.Comparisoncard.Content.Font.Align": {
    defaultValue: "left"
  },
  "Cardreport.Comparisoncard.Bg.Color": {
    ref: "Color.Transparent"
  },

  "Cardreport.Comparisoncard.Padding.Top": {
    defaultValue: "12px"
  },
  "Cardreport.Comparisoncard.Padding.Bottom": {
    defaultValue: "12px"
  },
  "Cardreport.Comparisoncard.Padding.Left": {
    defaultValue: "12px"
  },
  "Cardreport.Comparisoncard.Padding.Right": {
    defaultValue: "12px"
  },
  "Cardreport.Comparisoncard.Actualvalue.Color": {
    ref: "Color.Gray.900"
  },
  "Cardreport.Comparisoncard.Actualvalue.Font.Size": {
    ref: "Font.Size.24"
  },
  "Cardreport.Comparisoncard.Actualvalue.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },

  "Cardreport.Comparisoncard.Actualvalue.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Actualvalue.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Actualvalue.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Actualvalue.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Targetvalue.Color": {
    ref: "Color.Gray.900"
  },
  "Cardreport.Comparisoncard.Targetvalue.Font.Size": {
    ref: "Font.Size.18"
  },
  "Cardreport.Comparisoncard.Targetvalue.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },

  "Cardreport.Comparisoncard.Targetvalue.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Targetvalue.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Targetvalue.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Targetvalue.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Actuallabel.color": {
    ref: "Color.Gray.600"
  },
  "Cardreport.Comparisoncard.Actuallabel.Font.Size": {
    ref: "Font.Size.12"
  },
  "Cardreport.Comparisoncard.Actuallabel.Font.Weight": {
    ref: "Font.Weight.Medium"
  },

  "Cardreport.Comparisoncard.Actuallabel.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Actuallabel.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Actuallabel.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Actuallabel.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Targetlabel.Color": {
    ref: "Color.Gray.600"
  },
  "Cardreport.Comparisoncard.Targetlabel.Font.Size": {
    ref: "Font.Size.11"
  },
  "Cardreport.Comparisoncard.Targetlabel.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Cardreport.Comparisoncard.Targetlabel.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Targetlabel.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Targetlabel.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Targetlabel.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Comparisoncard.Content.Horizontal.Gap": {
    defaultValue: "20px"
  }
};
